export const ACCESS_TOKEN = 'Access-Token'
export const USER_NAME = 'User-Name'
export const THEME = 'THEME'